<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.users.company_users.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :exportable="this.$store.getters.hasPermission(['users', 'platform'], ['read'])"
                        :importable="true"
                        title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @exportButtonClick="onExportButton"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @rowClickRole="onRoleRow"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                    >
                    </data-table>
                    <b-btn class="btn btn-default mt-2 mr-2" @click="onAddRow" v-if="this.$store.getters.hasPermission(['users', 'platform'], ['create'])"><i class="fa fa-plus-circle mr-1"></i>{{ $t('general.users.company_users.create_button') }}</b-btn>

                    <span v-if="this.$store.getters.hasPermission(['users', 'platform'], ['create', 'update'])">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-primary mt-3" @click="$refs.importExcel.value = ''">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.users.import_button') }}</span>
                            <input type="file" name="file" style="display:none" ref="importExcel" @change="onImportButton($event.target.name, $event.target.files)" accept="application/*"/>
                        </label>
                        <label v-else class="btn btn-primary mt-3 disabled">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>
                </b-card>
                <div class="row">
                    <div class="col-sm-12">
                        <i class="fa fa-2x fa-user text-info"></i> - {{$t('general.buttons.roles')}}
                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="saveModal" :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress">
            <div class="row" v-if="!is_roles_visible">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.firstName') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.firstname">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.lastName') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.lastname">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.email') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="email" maxlength="50" class="form-control" v-model="model.email">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('profile.password') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <div v-if="row && !model.password">
                                <input type="password" maxlength="50" class="form-control" name="password" placeholder="" v-model="model.password">
                            </div>
                            <div v-else>
                                <input type="password" maxlength="50" class="form-control" v-model="model.password">
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('profile.confirmPassword') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <div v-if="this.row && !this.model.password">
                                <input type="password" maxlength="50" class="form-control" v-model="model.confirm_password">
                            </div>
                            <div v-else>
                                <input type="password" maxlength="50" class="form-control" v-model="model.confirm_password">
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.phone') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==15) return false;" class="form-control" v-model="model.phone_no">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('misc.location') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.location">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea maxlength="5000" rows="4" class="form-control" v-model="model.remarks"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.id_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="40" class="form-control" v-model="model.id_no">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="is_platform_admin">
                        <div class="col-lg-4">
                            <label>{{ $t('table.main_company_id') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedMainCompany"
                                :options="currentMainCompany"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isMainCompanyLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="name"
                                :selectLabel="''"
                                @search-change="onCompanySearch"
                                @input="updateMainCompany"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedMainCompany != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedMainCompany"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row mb-3">
                                <div class="col-lg-8">
                                    <label>{{ $t('table.isActive') }}</label>
                                </div>
                                <div class="col-lg-4" style="z-index: 0">
                                    <toggle-button v-model="model.active" :sync="true" :labels="toggleLabels"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="is_roles_visible">
                <div class="row mb-2">
                    <div class="col-lg-12 text-left">
                        <button class="btn btn-warning" @click="is_roles_visible=false"><i class="fa fa-arrow-left" aria-hidden="true"></i> {{ $t('table.go_back') }}</button>
                    </div>
                </div>

                <div class="row" style="z-index:100;position:relative;">
                    <div class="col-lg-12">
                        <label>{{ $t('table.user_exists_choose_a_role') }}</label>
                    </div>
                    <div class="col-lg-12">
                        <multiselect v-model="selectedRole"
                            :options="currentRoles"
                            :multiple="false"
                            :clear-on-select="true"
                            :hide-selected="false"
                            :loading="isRoleLoading"
                            :preserve-search="true" 
                            placeholder="" 
                            label="name" track-by="name" 
                            :selectLabel="''"
                            @search-change="onSelectRoleSearch"
                            @input="updateRole"
                        >
                            <template slot="clear" slot-scope="props">
                                <div 
                                    v-if="selectedRole != null" 
                                    class="multiselect__clear" 
                                    @mousedown.prevent.stop="clearSelectedRole"
                                >
                                </div>
                            </template>
                            <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                            <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                        </multiselect>
                    </div>
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete_user') }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import { Validator } from 'vee-validate';

import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

export default {
    name: 'users',
    components: {
        DataTable,
        ConfirmDialog,
        notificationIcons,
        Multiselect,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.users.title'),
                    active: true
                },
            ],
            tableNameTranslated: Vue.i18n.translate('general.users.company_users.title_modal'),
            tableName: 'user',
            tableLoaded: false,
            toggleLabels: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            row: null,
            actionTitle: '',
            userIds: [],

            selectedMainCompany: null,
            currentMainCompany: [],
            isMainCompanyLoading: false,

            is_roles_visible: false,

            selectedRole: null,
            currentRoles: [],
            isRoleLoading: false,

            model: {
                firstname: null,
                lastname: null,
                email: null,
                password: null,
                confirm_password: null,
                phone_no: null,
                location: null,
                data: null,
                team: null,
                job_title: null,
                job_superior: null,
                remarks: null,
                welder_no: null,
                id_no: null,
                main_company_id: null,
                welder_status: null,
                active: false,
                role_id: null,
            },
            getData: {
                rowData: []
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    field: '',
                    width: '120px',
                    showDeleteButton: true,
                    showEditButton: true,
                    showRolesButton: true
                },
                {
                    label: Vue.i18n.translate('table.firstName'),
                    field: 'firstname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.lastName'),
                    field: 'lastname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.email'),
                    field: 'email',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.phone'),
                    field: 'phone_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.owner_company'),
                    field: 'mainCompany',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.roles_in_companies'),
                    field: 'companiesName',
                    numeric: false,
                    html: false,
                    sortable: false,
                }
            ]
        }
    },
    computed: {
        is_platform_admin: {
            get: function () {
                if (typeof this.$store.state.userSelectedRole != 'undefined') {
                    if (typeof this.$store.state.userSelectedRole.permissions != 'undefined' && !this.$store.state.userSelectedRole.company_id) {
                        for (var key in this.$store.state.userSelectedRole.permissions) {
                            if (key == 'platform' && this.$store.state.userSelectedRole.permissions[key].update == 1) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            }
        }
    },
    watch: {
        is_company_admin: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    mounted () {
        this.onLoadTable();
        this.buttonYes = Vue.i18n.translate('misc.yes');
        this.buttonNo = Vue.i18n.translate('misc.no');
        this.toggleLabels = {checked: this.buttonYes, unchecked: this.buttonNo};
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        errorMessage(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable()
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onRoleRow (row, index) {
            this.$router.push({name: 'user_roles', params: {id: row.id}});
        },
        onLoadTable () {
            let data = http.route(this.tableName + '/getall?search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
            data.then(response => {
                if (response.isError == false) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;
                    
                    var data = response.data;
                        data.forEach(function(user,key) {
                            data[key]['companiesName'] = '';
                            data[key]['mainCompany'] = '';
                            if (data[key]['main_company_id']) {
                                data[key]['mainCompany'] = data[key]['main_company'].name;
                            }
                            let comps = {};
                            if (user.user_roles_with_info.length > 0) {
                                user.user_roles_with_info.forEach(function(role,key2) {
                                    if (role.company_id > 0) {
                                        if (typeof comps[role.company['name']] == 'undefined') comps[role.company['name']] = [];
                                        comps[role.company['name']].push(role['name']);
                                    }
                                });
                            }
                            let sep = '';
                            for (var key2 in comps) {
                                data[key]['companiesName'] += sep + Object.values(comps[key2]).join(", ") + ' - ' + key2;
                                sep = '; ';
                            }
                        });
                    this.getData.rowData = response.data;
                    this.tableLoaded = true;
                } else {
                    let msg = '';
                    Object.keys(response.errorMessage).forEach(key => {
                        msg += Vue.i18n.translate(response.errorMessage[key]) + "\n";
                    });
                    this.errorMsg(msg);
                }
            });
        },
        clearSearches () {
            this.selectedMainCompany  = null;
            this.currentMainCompany   = [];
            this.isMainCompanyLoading = false;

            this.selectedRole  = null;
            this.currentRoles  = [];
            this.isRoleLoading = false;
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.clearSearches();
            this.is_roles_visible = false;

            this.model.role_id = null;
            this.model.firstname = null;
            this.model.lastname = null;
            this.model.email = null;
            this.model.password = null;
            this.model.confirm_password = null;
            this.model.phone_no = null;
            this.model.location = null;
            this.model.data = null;
            this.model.team = null;
            this.model.job_title = null;
            this.model.job_superior = null;
            this.model.welder_no = null;
            this.model.welder_status = null;
            this.model.id_no = null;
            this.model.main_company_id = null;
            this.model.remarks = null;
            this.model.active = false;
            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated + ': ' + row.firstname + ' ' + row.lastname;
            this.row = row;
            this.clearSearches();
            this.is_roles_visible = false;

            this.model.firstname = this.row.firstname;
            this.model.lastname = this.row.lastname;
            this.model.email = this.row.email;
            this.model.role_id = null;
            this.model.password = null;
            this.model.confirm_password = null;
            this.model.phone_no = this.row.phone_no;
            this.model.location = this.row.location;
            this.model.data = this.row.data;
            this.model.team = this.row.team;
            this.model.job_title = this.row.job_title;
            this.model.job_superior = this.row.job_superior;
            this.model.remarks = this.row.remarks;
            this.model.id_no = this.row.id_no;
            this.model.active = Boolean(this.row.active);
            this.model.welder_no = this.row.welder_no;
            this.model.welder_status = this.row.welder_status;

            this.selectedMainCompany = null;
            if (this.row.main_company_id) {
                this.selectedMainCompany = [{name: this.row.main_company.name, id: this.row.main_company_id}];
            }
            this.model.main_company_id = this.row.main_company_id;

            this.$refs.saveModal.show();
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated + ': ' + row.firstname + ' ' + row.lastname;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        async saveAction (e) {
            e.preventDefault();

            this.errors.clear();

            if (this.is_roles_visible) {
                let put_data = {
                    id_no: this.model.id_no,
                    email: this.model.email,
                    role_id: this.model.role_id,
                };

                Object.keys(put_data).forEach(key => {
                    if (put_data[key] === '') {
                        put_data[key] = null;
                    }
                });

                let data = http.route(this.tableName).post(put_data, true);
                data.then(response => {
                    if (!response.isError) {
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.associated'));
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMessage(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                // var valid = false;
                // if (this.is_platform_admin) {//validate diff if superadmin
                //     console.log('sss');
                //     const v = new Validator();
                //     var { valid, errors } = await v.verify(this.model.email, 'required|email');
                //     if (!valid) {
                //         this.errors.add({
                //             field: 'email',
                //             msg: errors[0].replace('{field}', 'Email')
                //         });
                //     }
                // } else {
                //     valid = true;
                // }

                let put_data = {
                                firstname: this.model.firstname,
                                lastname: this.model.lastname,
                                //email: this.model.email,
                                confirm_password: this.model.confirm_password,
                                phone_no: this.model.phone_no,
                                location: this.model.location,
                                //welder_no: this.model.welder_no,
                                //welder_status: this.model.welder_status,
                                remarks: this.model.remarks,
                                id_no: this.model.id_no,
                                active: this.model.active,
                                };
                
                Object.keys(put_data).forEach(key => {
                    if (put_data[key] === '') {
                        put_data[key] = null;
                    }
                });

                if (this.is_platform_admin) {
                    put_data['main_company_id'] = this.model.main_company_id;
                }
                let pass = this.model.password;
                let email = this.model.email;
                if (pass) {
                    put_data['password'] = pass;
                }
                if (email) {
                    put_data['email'] = email;
                }
                if (this.row) {
                    let data = http.route(this.tableName + '/' + this.row.id).patch(put_data, true);
                    data.then(response => {
                        if(!response.isError) {
                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                            this.$refs.saveModal.hide();
                        } else {
                            var choose_role = false;
                            Object.keys(response.errorMessage).forEach(key => {
                                if (response.errorMessage[key] == 'errors.id_no.exists') {//|| response.errorMessage[key] == 'errors.email.exists'
                                    choose_role = true;
                                }
                                if (response.errorMessage[key] == 'errors.id_no.exists1') {//|| response.errorMessage[key] == 'errors.email.exists'
                                    //choose_role = true;
                                }
                            });
                            if (!this.is_platform_admin && choose_role) {
                                this.errorMessage(Vue.i18n.translate('errors.user_exists_choose_a_role'));
                                this.selectRole();
                            } else {
                                Object.keys(response.errorMessage).forEach(key => {
                                    this.errorMessage(Vue.i18n.translate(response.errorMessage[key]));
                                });
                            }
                        }
                    });
                } else {
                    let data = http.route(this.tableName).post(put_data, true);
                    data.then(response => {
                        if(!response.isError) {
                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                            this.$refs.saveModal.hide();
                        } else {
                            var choose_role = false;
                            Object.keys(response.errorMessage).forEach(key => {
                                if (response.errorMessage[key] == 'errors.id_no.exists') {
                                    choose_role = true;
                                }
                            });
                            if (!this.is_platform_admin && choose_role) {
                                this.errorMessage(Vue.i18n.translate('errors.user_exists_choose_a_role'));
                                this.selectRole();
                            } else {
                                Object.keys(response.errorMessage).forEach(key => {
                                    this.errorMessage(Vue.i18n.translate(response.errorMessage[key]));
                                });
                            }
                        }
                    });
                }
            }
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route('user/' + this.row.id).delete();
                data.then(response => {
                    if (response.isError == false) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }

            this.$refs.deleteModal.hide();
        },
        onExportButton() {
            http.route('user/getall?get_all=1').exportExcel({
                export: 1,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'users.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onImportButton(fieldName, fileList) {
            const formData = new FormData();

            if (!fileList.length) return;

            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });

            http.route(this.tableName+'/import').importExcel(formData).then(response => {
                if (response.isError) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.onLoadTable();
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.imported'));
                }
            });
        },
        onCompanySearch(search) {
            if (search == '') {
                this.currentMainCompany = [];
                
                return false;
            }

            this.isMainCompanyLoading = true;
            this.search(search, this);
        },
        search: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentMainCompany = response.data;
                }
                vm.isMainCompanyLoading = false;
            });
        }, 500),
        updateMainCompany(company) {
            this.model.main_company_id = (company != null) ? company.id : null;
        },
        clearSelectedMainCompany () {
            this.selectedMainCompany   = null;
            this.model.main_company_id = null;
        },
        onSelectRoleSearch(search) {
            if (search == '') {
                this.currentRoles = [];
                
                return false;
            }

            this.isRoleLoading = true;
            this.searchRole(search, this);
        },
        searchRole: _.debounce((search, vm) => {
            let data = http.route('roles' + '?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentRoles = response.data;
                }
                vm.isRoleLoading = false;
            });
        }, 500),
        updateRole(role) {
            this.model.role_id = (role != null) ? role.id : null;
        },
        clearSelectedRole () {
            this.selectedRole  = null;
            this.model.role_id = null;
        },
        selectRole() {
            this.is_roles_visible = true;
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/users/users.vue